$('.developments-slider').slick({
    lazyLoad: 'ondemand',
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    centerMode: false,
    variableWidth: false,
    prevArrow: '<div class="slick-prev slick-arrow d-flex align-items-center justify-content-center"><img src="/assets/img/left-arrow-white-min.png" alt="Left Arrow Icon"></div>',
    nextArrow: '<div class="slick-next slick-arrow d-flex align-items-center justify-content-center"><img src="/assets/img/right-arrow-white-min.png" alt="Right Arrow Icon"></div>',
});

$('[data-fancybox="gallery"]').fancybox({
    buttons: [
        "slideShow",
        "thumbs",
        "close"
    ],
    loop: true
});

$(document).ready(function() {
    $(window).scroll(function() {
        var distanceFromTop = $(document).scrollTop();
        if (distanceFromTop >= $('#scroll-passed1').height()) {
            $('.sticky-bar').addClass('fixed100');
        } else {
            $('.sticky-bar').removeClass('fixed100');
        }

        if (distanceFromTop >= $('#scroll-passed').height()) {
            $('.sticky-bar').addClass('fixed');
        } else {
            $('.sticky-bar').removeClass('fixed');
        }
    });
});
